module.exports = __webpack_public_path__ + "static/MattiasB-e34fb53556aaf3958b61fd6a162ea777.gif";